import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/shadefinder/debug"
    exact
    path="/business/showcase/shadefinder/debug"
    component={AsyncPage}
  />,
];
